import React from 'react';
import { Link } from 'react-router-dom';

export class FifthStep extends React.Component {
  render () {
    return (
      <div className="container container_bg container_opacity">
        <div className="content">
          <div className="transactions-title">
            <h1 className="title"><strong>表名</strong></h1>
            <p className="title">Total: <strong>3789.093 ETH</strong></p>
          </div>
          <div className="table">
            <div className="table-tr table-tr_title">
              <div className="table-td">Token 名称</div>
              <div className="table-td">地址</div>
              <div className="table-td">数量</div>
            </div>
            <div className="table-tr">
              <div className="table-td">
                <p>Name 1</p>
              </div>
              <div className="table-td">
                <p className="break-all">0xc6300135a8fcd43123bb486ff06831b5345d0971</p>
              </div>
              <div className="table-td">
                <p>2.5672 ETH</p>
              </div>
            </div>
            <div className="table-tr">
              <div className="table-td">
                <p>Name 2</p>
              </div>
              <div className="table-td">
                <p className="break-all">0x0a7772cdbeee6dbdfdf944dd3e11d32d6a183bde</p>
              </div>
              <div className="table-td">
                <p>8.009 ETH</p>
              </div>
            </div>
          </div>
          <Link className="button button_next" to='/'>返回主页</Link>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/5.js